import { useCurrency } from "./useCurrency";
import { useLanguage } from "./useLanguage";

const STYLE = "currency";
export function useFormattedPrice(amount: number, options: Intl.NumberFormatOptions = {}) {
    const languageFromContext = useLanguage();
    const currencyFromContext = useCurrency();

    return new Intl.NumberFormat(languageFromContext.code, {
        style: STYLE,
        ...options,
        currency: options.currency ?? currencyFromContext,
    }).format(amount);
}
